import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Add } from '@mui/icons-material';
import { Box, Button, IconButton, LinearProgress, Link, Tooltip } from "@mui/material";
import { DataGridPro, GridColDef, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import { PartnersModel } from "../../models/PartnersModel";
import { stateOptions } from "../AddEdit/AddEditPartners";
import { text } from 'stream/consumers';
import moment from 'moment';
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from '../../helper/api';
interface Iprops {
    PartnersCL: PartnersModel[],
    fetchData: () => void
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

export const PartnersList: React.FC<Iprops> = ({ PartnersCL, fetchData, sortModel, setSortModel }) => {
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    const initialLBData: PartnersModel = {
        partnersId: 0,
        customerName: "",
        streetAddress: "",
        suitOrUnit: "",
        city: "",
        state: 0,
        zipCode: "",
        agencyLicense: "",
        taxId: "",
        numberOfStates: "",
        filingContactName: "",
        filingContactEmail: "",
        filingContactPhone: "",
        accountingContactName: "",
        accountingContactEmail: "",
        accountingContactPhone: "",
        licenseeContactName: "",
        licenseeContactEmail: "",
        licenseeContactPhone: "",
        slaAdminContactName: "",
        slaAdminContactEmail: "",
        slaAdminContactPhone: "",
        escalationContactName: "",
        escalationContactEmail: "",
        escalationContactPhone: "",
        drlpContactName: "",
        drlpContactEmail: "",
        drlpContactPhone: "",

        paymentPartnerType: 0,
        paymentStreetAddress: "",
        paymentSuitOrUnit: "",
        paymentCity: "",

        paymentZipCode: 0,
        paymentNaic: "",
        paymentTaxId: "",
        partnerIntegrationType: 0,
        agencyPolicyManagementSystem: "",
        userName: "",
        password: "",

        modifiedBy: 0,
        paymentType: true,
        paymentState: 0,
        createdBy: 0,

        status: false,

    }

    const [partnerStates, setPartnerStates] = useState<stateOptions[]>([]);
    const [Open, setOpen] = React.useState(false);
    const [Formdata, setFormData] = React.useState<PartnersModel>(initialLBData);
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const handleClose = () => {

        setOpen(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);
    };
    const handleClickOpen = () => {
        setPartnerStates([]);
        setFormData(initialLBData);
        setOpen(true);
    };

    const handleEdit = (ILobData: PartnersModel) => {

        apiClient(`/Partners/getPartnerStates?partnersId=${ILobData.partnersId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response
                console.log(responseJson.data, "fetchdata");
                setPartnerStates(responseJson.data);
                // setSelectedOption(States.filter(x => partnerStates.map((item)=>(item.stateId))));
            })
        setFormData(ILobData);

        setOpen(true);
    };

    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/Partners/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )
                            fetchData();
                            setOpen(false);
                        })

                }
            })
    };

    function EditToolbar() {
        return (
            <Box sx={{
                borderBottom: 1,
                borderColor: 'divider',
                p: 1,
            }}>
                <GridToolbarFilterButton />
            </Box>
        );
    }
    const columns: GridColDef[] = [
        {
            field: 'customerName', type: 'text', headerName: 'Client Name', headerAlign: "left", hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'customerName'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, flex: 1, align: 'left'
        },
        // {
        //     field: 'status', type: 'boolean', headerName: 'Status', headerAlign: 'center', align: 'center', flex: 0.8,
        //     renderCell: (params) =>
        //     (
        //         <div>
        //             {params.row.status ? "Active" : "Inactive"}
        //         </div>
        //     )
        // },

        {
            field: 'status', type: 'text', headerName: 'Status', headerAlign: "left", flex: 0.8, hideSortIcons: true, minWidth: 100,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'status'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, align: 'left',
            valueGetter: (params) => {
                return (params.row?.status ? "Active" : "InActive")
            }

        },

        {
            field: 'dateCreated', headerName: 'Start Date', headerAlign: "left", flex: 1, align: 'left', hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dateCreated'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, renderCell: (params) =>
            (
                <div>

                    {/* {params.row?.effectiveDate ? moment(params.row?.effectiveDate).format("MM/DD/YYYY") : ""} */}
                    {params.row.dateCreated?.toString().split('T')[0]}
                </div>
            )
        },
        {
            field: 'partnersId', flex: 0.5, headerName: "Action", headerAlign: "center", align: 'center', hideSortIcons: true, minWidth: 100,
            filterable: false, 
            sortable: false,
            disableColumnMenu: true,
            disableExport: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), renderCell: (params) =>
            (<div>

                <Link href={'/AddEditPartners/' + params.value} sx={{ textDecoration: "none " }}>
                    {/* <button type="button" className="btn btn-primary action-btn"> <i className="fa-solid fa-right-long"></i></button> */}
                    <IconButton
                        color="primary"
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                    >  <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                        <EditOutlinedIcon fontSize="small" color="primary" />
                    </Tooltip>
                    </IconButton >
                </Link>
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.partnersId); }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>
                    </IconButton>
                    : ""}
            </div>)
        },

    ];

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.5,
                    px: { xs: 4, lg: 2 },
                    py: 1.5,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 56,
                    mb: 3,
                    marginLeft: { xs: '-24px', lg: '0px' },
                    marginRight: { xs: '-24px', lg: '0px' },
                }}
            >
                <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
                    Clients
                </h4>
                {user?.userRoles.split(",").includes("Super Admin") ? (
                    <Button
                        component={Link}
                        href={'/AddEditPartners/' + 0}
                        variant="contained"
                        size="medium"
                        startIcon={<Add />}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            backgroundColor: '#2099d2',
                            '&:hover': { backgroundColor: '#176990', color: '#ffffff' },
                            textDecoration: 'none',
                        }}
                    >
                        Add New
                    </Button>
                ) : null}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    height: 'calc(100vh - 250px)',
                }}
            >
                <DataGridPro
                    getRowId={(r) => r.partnersId}
                    rows={PartnersCL}
                    columns={columns}
                    pageSize={50}
                    rowsPerPageOptions={[50]}
                    components={{
                        Toolbar: EditToolbar,
                    }}
                    onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                    sortModel={sortModel}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        '& .MuiDataGridPro-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.35,
                            fontWeight: 600,
                            fontSize: '12px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: '#64748b',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            borderTop: '2px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            '&:focus, &:focus-within': { outline: 'none' },
                        },
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease',
                            '&:nth-of-type(even)': {
                                backgroundColor: '#fafbfc',
                            },
                            '&:hover': {
                                backgroundColor: '#f1f5f9 !important',
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            overflow: 'visible',
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            wordWrap: 'break-word',
                            textOverflow: 'clip',
                            padding: '8px 16px',
                            '&:focus': { outline: 'none' },
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            marginBottom: '0px !important',
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-main': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        '& .MuiIconButton-root': {
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                    }}
                />
            </Box>
        </div>
    )
}